import { getDay } from './dateTime'

export default ({ open, hours }) => {
  const today = hours.filter((time) => {
    return time.day === getDay().toUpperCase()
  })

  return {
    online: open,
    openingHours: today[0],
  }
}
